import MaterialItem from "./material-item";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

// Material Selection Panel
const MaterialSelectionPanel = ({
    type, // 'source' or 'target'
    title,
    subTitle,
    materials,
    total,
    page,
    loading,
    searchQuery,
    selectedMaterial,
    itemsPerPage,
    onSearchChange,
    onSearchSubmit,
    onPageChange,
    onSelect,
    onClear
}) => {
    // Dynamic styles based on type
    const themeColor = type === 'source' ? 'warning' : 'success';
    const totalPages = Math.ceil(total / itemsPerPage);

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') onSearchSubmit();
    };

    return (
        <div data-cy={`${type}-panel`} className="card shadow-sm h-100">
            {/* Dynamic Header Style */}
            <div className={`card-header bg-${themeColor} bg-opacity-10 border-bottom border-${themeColor}`}>
                <div className="d-flex align-items-center justify-content-between">
                    <div className="text-start">
                        <h5 className="mb-0">{title}</h5>
                        <small className="text-muted">{subTitle}</small>
                    </div>
                    {selectedMaterial && (
                        <button
                            data-cy={`clear-${type}-selection`}
                            className="btn btn-sm btn-outline-secondary btn-clear"
                            onClick={onClear}
                        >
                            <CloseIcon className="close-icon" /> Clear Selection
                        </button>
                    )}
                </div>
            </div>

            <div className="card-body d-flex flex-column">
                <div className="search-container sticky-top bg-white pt-3 pb-2">
                    <div className="input-group">
                        <span
                            data-cy={`${type}-search-btn`}
                            className="input-group-text"
                            type="button"
                            onClick={onSearchSubmit}
                            disabled={loading}
                        >
                            <SearchIcon className="search-icon" />
                        </span>
                        <input
                            data-cy={`${type}-search-input`}
                            type="text"
                            className="form-control"
                            placeholder="Search by name or part number..."
                            value={searchQuery}
                            onChange={(e) => onSearchChange(e.target.value)}
                            onKeyPress={handleKeyPress}
                        />
                    </div>
                </div>

                <div className="materials-list flex-grow-1">
                    {loading ? (
                        // Show skeleton loaders when loading
                        Array.from({ length: 5 }).map((_, index) => (
                            <MaterialItem
                                key={`skeleton-${index}`}
                                material={null}
                                isSelected={false}
                                type={type}
                                onSelect={() => {}}
                                loading={true}
                            />
                        ))
                    ) : materials.length === 0 ? (
                        <div className="text-center text-muted py-5">
                            <p>No materials found</p>
                        </div>
                    ) : (
                        materials.map((material) => (
                            <MaterialItem
                                key={material.id}
                                material={material}
                                isSelected={selectedMaterial?.id === material.id}
                                type={type}
                                onSelect={onSelect}
                                loading={false}
                            />
                        ))
                    )}
                </div>
            </div>

            {totalPages > 1 && (
                <div className="card-footer">
                    <div className="d-flex justify-content-between align-items-center">
                        <small className="text-muted brand-color-1">
                            Showing {((page - 1) * itemsPerPage) + 1} - {Math.min(page * itemsPerPage, total)} of {total}
                        </small>
                        <div className="btn-group btn-group-sm">
                            <button
                                data-cy={`${type}-prev-btn`}
                                className="btn btn-outline-secondary brand-color-1 prev"
                                onClick={() => onPageChange(page - 1)}
                                disabled={page === 1 || loading}
                            >
                                Previous
                            </button>
                            <button className="btn btn-outline-secondary brand-color-1" disabled>
                                {page} / {totalPages}
                            </button>
                            <button
                                data-cy={`${type}-next-btn`}
                                className="btn btn-outline-secondary brand-color-1 next"
                                onClick={() => onPageChange(page + 1)}
                                disabled={page === totalPages || loading}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};


export default MaterialSelectionPanel;
